<template>
  <vxe-grid
    v-bind="gridOptions"
    :data="viewTableData"
    :columns="tableColumns"
    :span-method="mergeRowMethod"
    resizable
  >
  </vxe-grid>
</template>
<script>
import { request } from '@/api/service'
import tableColumns from './table-columns'
import dayjs from '@/libs/util.date'
export default {
  props: {
    orderCode: String
  },
  data() {
    return {
      gridOptions: {
        border: 'full',
        size: 'mini',
        toolbarConfig: {
          zoom: true
        },
        seqConfig: {
          seqMethod: (params) => this.seqMethod(params)
        }
      },
      tableData: [],
      result: {
        batchList: []
      }
    }
  },
  computed: {
    tableColumns() {
      const baseColumns = tableColumns(this)
      if (!this.result.batchList.length) return baseColumns

      //生成新的日期表头
      const times = this.result.batchList
        .map((i) => i.deliveryDate)
        .filter((e, i, t) => t.indexOf(e) === i)
        .map((i) => new Date(dayjs(i)))
        .sort((i, j) => i - j)
        .map((i) => dayjs(i).format('YYYY-MM-DD'))

      const columnGroup = times.map((val) => this.generateGroupColumn(val))
      baseColumns.push(...columnGroup)
      return baseColumns
    },
    viewTableData() {
      const tableData = this.result.batchList
      if (!tableData || !tableData.length) return []

      const newTableData = tableData.reduce((result, item) => {
        const key = `${item.orderGoodsNo}`
        if (!result[key]) {
          result[key] = item
        }

        if (this.result.orderType === 'domesticTrade') {
          // 订单类型为内贸
          let value = result[key][item.deliveryDate] || 0
          value += item.orderBatchGoodsQty
          result[key][item.deliveryDate] = value
        } else {
          // 订单类型为外贸
          // 出单类型 storeBill-店铺 onlineBill-网单
          const outBillType = item.outBillType
          const timeData = result[key][item.deliveryDate] || {
            storeBill: 0,
            onlineBill: 0
          }
          timeData[outBillType] += item.orderBatchGoodsQty
          result[key][item.deliveryDate] = timeData
        }

        return result
      }, {})
      return Object.values(newTableData)
    },
    mergeCellByKey() {
      const mergeByKey = this.tableColumns.find((c) => c.mergeByKey)
      return mergeByKey ? mergeByKey.field : ''
    },
    mergeCell() {
      return this.tableColumns.filter((c) => c.merge).map((c) => c.field)
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      request({
        url: '/factory/orderBatch/listByGoods',
        method: 'post',
        data: {
          orderCode: this.orderCode
        }
      }).then((res) => {
        this.result = res.body
      })
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      if (!this.mergeCellByKey) {
        return { rowspan: 1, colspan: 1 }
      }
      const fields = this.mergeCell
      const cellValue = row[this.mergeCellByKey]

      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]

        if (prevRow && prevRow[this.mergeCellByKey] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[this.mergeCellByKey] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    generateGroupColumn(field) {
      // 订单类型为内贸
      if (this.result.orderType === 'domesticTrade') {
        return {
          title: field,
          field,
          align: 'center',
          width: 90
        }
      }

      // 订单类型为外贸
      const groupColumn = {
        title: field,
        align: 'center',
        children: [
          {
            title:
              this.$l('INDEX.order_batch_table_label_store') || 'Store店铺',
            field: `${field}.storeBill`,
            width: 90,
            align: 'center'
          },
          {
            title: this.$l('INDEX.order_batch_table_label_ecom') || 'Ecom网单',
            field: `${field}.onlineBill`,
            width: 90,
            align: 'center'
          }
        ]
      }
      return groupColumn
    },
    seqMethod(params) {
      const { row, visibleData } = params
      let group = []
      visibleData.forEach((i) => {
        if (group.indexOf(i.orderGoodsNo) < 0) {
          group.push(i.orderGoodsNo)
        }
      })
      return group.indexOf(row.orderGoodsNo) + 1
    }
  }
}
</script>
